import { TimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import React from "react";

export const StyledTimePicker = ({
	label,
	value,
	onChange,
	error,
	textFieldSx = { marginTop: "16px", marginBottom: "8px" },
	disabled = false,
	name,
}) => {
	const [selectedSections, setSelectedSections] = React.useState(0);
	return (
		<TimePicker
			name={name}
			disabled={disabled}
			selectedSections={selectedSections}
			onSelectedSectionsChange={(newValue) => {
				setSelectedSections(newValue);
			}}
			disableOpenPicker={true}
			label={label}
			value={moment(value) || null}
			onChange={(newValue) => {
				if (!newValue) return onChange(null);

				const date = new Date(newValue._d);
				onChange(date);
			}}
			desktopModeMediaQuery=""
			format="HH:mm"
			slotProps={{
				textField: {
					onFocus: () => {
						setSelectedSections("hours");
					},
					onBlur: (e) => {
						if (e.target.value !== "hh:mm" && e.target.value.includes("mm")) {
							const hours = Number(e.target.value.split(":")[0]);
							const newDate = new Date();
							newDate.setHours(hours);
							newDate.setMinutes(0);
							onChange(newDate);
						}
					},
					onKeyUp: (e) => {
						if (
							(e.key === "Backspace" || e.key === "Delete") &&
							e.target.value !== "hh:mm" &&
							e.target.value.includes("mm")
						) {
							setSelectedSections(0);
						}

						if (e.key === "Tab") {
							setSelectedSections("hours");
						}
					},
					size: "small",
					error: error,
					sx: textFieldSx,
					InputLabelProps: { shrink: true },
				},
			}}
		/>
	);
};
